export default __webpack_public_path__ + "static/media/water.cc545ce1.png";